module.exports = __webpack_public_path__ + "static/img/HuangMu_Banner.d5d6ed93.jpg";